/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RestockingItemInput = {
  sku: string;
  source?: RestockingSource | null | undefined;
};

export type RestockingSource = "MANUAL" | "PICKING";

export type SaveSkuToPublicRestockingListMutationVariables = Exact<{
  input: Types.RestockingItemInput;
}>;

export type SaveSkuToPublicRestockingListMutation = {
  saveSkuToPublicRestockingList: { success: boolean };
};

export const SaveSkuToPublicRestockingListDocument = gql`
  mutation saveSkuToPublicRestockingList($input: RestockingItemInput!) {
    saveSkuToPublicRestockingList(input: $input) {
      success
    }
  }
`;
export type SaveSkuToPublicRestockingListMutationFn = Apollo.MutationFunction<
  SaveSkuToPublicRestockingListMutation,
  SaveSkuToPublicRestockingListMutationVariables
>;

/**
 * __useSaveSkuToPublicRestockingListMutation__
 *
 * To run a mutation, you first call `useSaveSkuToPublicRestockingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSkuToPublicRestockingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSkuToPublicRestockingListMutation, { data, loading, error }] = useSaveSkuToPublicRestockingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSkuToPublicRestockingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveSkuToPublicRestockingListMutation,
    SaveSkuToPublicRestockingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveSkuToPublicRestockingListMutation,
    SaveSkuToPublicRestockingListMutationVariables
  >(SaveSkuToPublicRestockingListDocument, options);
}
export type SaveSkuToPublicRestockingListMutationHookResult = ReturnType<
  typeof useSaveSkuToPublicRestockingListMutation
>;
export type SaveSkuToPublicRestockingListMutationResult =
  Apollo.MutationResult<SaveSkuToPublicRestockingListMutation>;
export type SaveSkuToPublicRestockingListMutationOptions = Apollo.BaseMutationOptions<
  SaveSkuToPublicRestockingListMutation,
  SaveSkuToPublicRestockingListMutationVariables
>;
